import React from 'react';
import { useTranslation } from 'react-i18next';
import VoucherRegisterReport from '@/components/finance/report-document/VoucherRegisterReport';

const PaymentRegisterPage: React.FC = () => {
  const { t } = useTranslation('finance');
  return (
    <div aria-label={t('paymentRegister')}>
      <VoucherRegisterReport kind="payment" />
    </div>
  );
};

export default PaymentRegisterPage;
